export default __webpack_public_path__ + "static/media/alisa.aee923c9.jpg";